import React, { ReactNode } from 'react';

interface MainContentWrapperProps {
  children: ReactNode;
  className?: string;
}

const MainContentWrapper: React.FC<MainContentWrapperProps> = ({ children }) => {
  return <div className="h-full w-full">{children}</div>;
};

export default MainContentWrapper;
